import PropTypes from 'prop-types'
import React from 'react'
import clsx from 'clsx'
import { withI18next } from 'lib/i18n/withI18next'
import { hasLocizeTranslation } from 'lib/utils/locize'
import Icon, { ICONS, ICON_SIZE } from 'components/common/icon'
import VirtualTryOnModal from 'components/shared/virtual-try-on-modal/VirtualTryOnModal'
import Typo from 'constants/typography'
import Button from 'components/common/button'
import { BUTTON_TYPES } from 'constants/button'
import styles from './product-virtual-try-on.scss'

const ProductVirtualTryOn = ({
  t,
  isPhone,
  productId,
  isVirtualTryOn,
  compact,
}) => {
  if (compact) {
    return (
      <React.Fragment>
        <style jsx>{styles}</style>
        <VirtualTryOnModal
          isPhone={isPhone}
          productId={productId}
          isVirtualTryOn={isVirtualTryOn}
          triggerButton={
            <Button
              type={BUTTON_TYPES.link}
              className="pdp__virtual-try-on-compact"
            >
              <Icon size={ICON_SIZE.medium} src={ICONS.virtualHanger} alt="" />
              {hasLocizeTranslation(t, 'TRY_IT_ON', 'Try It On')}
            </Button>
          }
        />
      </React.Fragment>
    )
  }
  return (
    <React.Fragment>
      <style jsx>{styles}</style>
      <VirtualTryOnModal
        isPhone={isPhone}
        productId={productId}
        isVirtualTryOn={isVirtualTryOn}
        triggerButton={
          isPhone ? (
            <div role="button" className="pdp__virtual-try-on-cta-mobile">
              <div className={clsx('pdp__virtual-try-on-cta-mobile__wrapper')}>
                <div className="pdp__virtual-try-on-cta-mobile__text">
                  <Icon
                    size={ICON_SIZE.medium}
                    src={ICONS.virtualHanger}
                    alt="virtual hanger icon"
                  />
                  <span className={Typo.subtitle2}>
                    {hasLocizeTranslation(t, 'TRY_IT_ON', 'Try It On')}
                  </span>
                </div>
              </div>
            </div>
          ) : (
            <div className="pdp__virtual-try-on-cta-desktop">
              <div className="pdp__virtual-try-on-cta-desktop__text">
                <Icon
                  size={ICON_SIZE.medium}
                  src={ICONS.virtualHanger}
                  alt="virtual hanger icon"
                />
                <span className={Typo.body2}>
                  {hasLocizeTranslation(
                    t,
                    'PDP_TRY_IT_ON_VIRTUALLY',
                    'Tap to try, before you buy - virtually!',
                  )}
                </span>
              </div>
              <Button
                className="pdp__virtual-try-on-cta-desktop__button"
                type={BUTTON_TYPES.primary}
              >
                {hasLocizeTranslation(t, 'TRY_IT_ON', 'Try It On')}
              </Button>
            </div>
          )
        }
      />
    </React.Fragment>
  )
}

ProductVirtualTryOn.defaultProps = {
  compact: false,
  isPhone: false,
  isVirtualTryOn: false,
}

ProductVirtualTryOn.propTypes = {
  compact: PropTypes.bool,
  isPhone: PropTypes.bool,
  t: PropTypes.func.isRequired,
  productId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  isVirtualTryOn: PropTypes.bool,
}

export default withI18next()(ProductVirtualTryOn)
